(function () {
  'use strict';

  var DURATION = 1200;

  function parseTarget(raw) {
    var match = raw.trim().match(/^([\d,]+)(.*)$/);
    if (!match) return null;
    return {
      value: parseInt(match[1].replace(/,/g, ''), 10),
      suffix: match[2] || ''
    };
  }

  function animateCount(el) {
    var raw = el.getAttribute('data-count-to') || el.textContent;
    var target = parseTarget(raw);
    if (!target || isNaN(target.value)) return;

    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / DURATION, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target.value);
      /* en-US, not en-IN: Indian digit grouping is lakh-based, so 100000 renders
         as "1,00,000" instead of "100,000". Identical below six figures, which is
         why it has never shown on the current counters — and wrong the day one of
         them passes 100,000. */
      el.textContent = current.toLocaleString('en-US') + target.suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = target.value.toLocaleString('en-US') + target.suffix;
      }
    }

    el.textContent = '0' + target.suffix;
    window.requestAnimationFrame(step);
  }

  function init() {
    // Bound at document level rather than to a section root: the page is a stack
    // of sibling <section>s and a future split into separate Shopify sections
    // would break any root-scoped lookup (CLAUDE.md §10.35).
    var nums = document.querySelectorAll('.ksus__stat-number[data-count-to]');
    if (!nums.length) return;

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return; // leave server-rendered final values in place
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    nums.forEach(function (num) {
      if (num.dataset.ksusCounted === '1') return;
      num.dataset.ksusCounted = '1';
      observer.observe(num);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', init);
})();
